var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEs = function SvgEs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#01e3c8b7-832f-4d14-99f8-7621c5d550fda)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "277e8227-0b59-4e11-91cd-ce10ad2da6b8b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#277e8227-0b59-4e11-91cd-ce10ad2da6b8b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CD0B20",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB00",
    fillRule: "evenodd",
    d: "M0 4h21v7H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B47C",
    fillRule: "evenodd",
    d: "M9 6.222v2.52c0 .7-.672 1.26-1.5 1.26h-2C4.674 10 4 9.437 4 8.74V6.22c0-.572.448-1.05 1.064-1.205.186-.52.758-.054 1.436-.054.682 0 1.25-.463 1.436.055C8.55 5.175 9 5.654 9 6.222",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5B5B5",
    fillRule: "evenodd",
    d: "M9 7h1v3H9zM3 7h1v3H3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#165C96",
    fillRule: "evenodd",
    d: "M9 9h1v1H9zM3 9h1v1H3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0790A",
    fillRule: "evenodd",
    d: "M9 6h1v1H9zM3 6h1v1H3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D20636",
    fillRule: "evenodd",
    d: "M5 6h1v1.5H5zm2 2h1v1.5H7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A18793",
    fillRule: "evenodd",
    d: "M7 6h1v1.5H7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE100",
    fillRule: "evenodd",
    d: "M5 8h1v1.5H5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6161A",
    fillRule: "evenodd",
    d: "M6 6 5 5h3L7 6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC9300",
    fillRule: "evenodd",
    d: "M6 4h1v1H6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "01e3c8b7-832f-4d14-99f8-7621c5d550fda"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgEs;